import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { getApiBaseUrl } from "../api/utils";
import "./LoginModal.css";

const API_URL = getApiBaseUrl();

export function SignupScreen({ defaultValue = "", onNavigateToLogin, onSuccess }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState(defaultValue);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleSignup = async () => {
    setLoading(true);
    setError("");

    try {
      if (!name.trim()) {
        throw new Error("Please enter a username or display name.");
      }
      if (!email.trim() && !phone.trim()) {
        throw new Error("Please enter either email or phone number.");
      }
      if (password.length < 6) {
        throw new Error("Password must be at least 6 characters.");
      }
      if (password !== confirmPassword) {
        throw new Error("Passwords do not match.");
      }

      const res = await fetch(`${API_URL}/users/register/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim() || null,
          mobile_number: phone.trim() || null,
          password,
          otp: "1111",
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Signup failed");

      if (data.access_token) {
        await login(data.access_token);
        onSuccess(data.access_token);
      } else {
        onSuccess();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="auth-modal-title">Sign Up</h2>
      <p className="auth-modal-subtitle">
        Create an account to RSVP, comment, and view private event memories.
      </p>

      <label className="auth-modal-form-group">
        <span className="auth-modal-label">Username / display name</span>
        <input
          type="text"
          placeholder="e.g. Deepak"
          className="auth-modal-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </label>
      <label className="auth-modal-form-group">
        <span className="auth-modal-label">Email</span>
        <input
          type="email"
          placeholder="you@example.com"
          className="auth-modal-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <label className="auth-modal-form-group">
        <span className="auth-modal-label">Phone number</span>
        <input
          type="tel"
          placeholder="Optional if email is provided"
          className="auth-modal-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </label>
      <label className="auth-modal-form-group">
        <span className="auth-modal-label">Password</span>
        <input
          type="password"
          placeholder="Create a password"
          className="auth-modal-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </label>
      <label className="auth-modal-form-group">
        <span className="auth-modal-label">Confirm password</span>
        <input
          type="password"
          placeholder="Re-enter password"
          className="auth-modal-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </label>

      {error && <p className="auth-modal-error-msg">{error}</p>}

      <button
        onClick={handleSignup}
        disabled={loading}
        className="auth-modal-submit-btn"
      >
        {loading ? "Creating Account..." : "Sign Up"}
      </button>

      <p className="mt-4 text-center text-sm">
        Already have an account?{" "}
        <button className="auth-modal-inline-button" onClick={onNavigateToLogin}>
          Login
        </button>
      </p>
    </div>
  );
}
